import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_STATUS,
  COLUMN_INACTIVITY_PERIOD,
  COLUMN_IMPRESSION_ATTRIBUTION,
  COLUMN_CLICK_ATTRIBUTION,
  COLUMN_DAYS_BETWEEN_REMARKETING,
  COLUMN_TRACK_RE,
} from 'scenes/Applications/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_STATUS,
    COLUMN_INACTIVITY_PERIOD,
    COLUMN_IMPRESSION_ATTRIBUTION,
    COLUMN_CLICK_ATTRIBUTION,
    COLUMN_DAYS_BETWEEN_REMARKETING,
    COLUMN_TRACK_RE,
  ]),
  collapsed: array(string()).default([]),
});
